import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames/bind";
import {
  Previous,
  List,
  SearchBlack,
} from "../../../../components/Icons/Icons";
import { Link, useParams } from "react-router-dom";
import axiosClient from "../../../../services/axiosClient";
import useFetchData from "../../../../hooks/useFetchData";
import { InputTextBox, Toast, Loading } from "../../../../components";
import ModalCamera from "./ModalCamera";
import ModalInfo from "../../Camera/ModalInfo";
import TableCamera from "./TableCamera";
import { groupCameraManagement } from "../../../../services/api/GroupCameraManagement";
import { formatDDMMYY } from "../../../../utils";
import styles from "./EditGroup.module.css";
import InfoUserItem from "../../../InfoUser/ShowInfoUser/InfoUserItem";

const cx = classNames.bind(styles);
const EditGroup = () => {
  const params = useParams();
  const ref = useRef(null);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [listCamera, setListCamera] = useState([]);
  const [listCamSelect, setListCamSelect] = useState([]);
  const [textSearch, setTextSearch] = useState();
  const [group, setGroup] = useState();
  const [isRefresh, setIsRefresh] = useState(false);
  const [input, setInput] = useState();
  const [isModalInfo, setIsModalInfo] = useState(false);
  const [code, setCode] = useState("");
  const [province, setProvince] = useState();
  const [district, setDistrict] = useState();
  const [commune, setCommune] = useState();
  const [nameCamera, setNameCamera] = useState();
  const [status, setStatus] = useState("Tất cả");
  const [loading, setLoading] = useState(false)
  const onChangeTextSearch = (data) => {
    setInput(data);
    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      setTextSearch(data);
    }, 300);
  };
  const handleClick = () => {
    setShowModal(true);
    setTextSearch();
    setInput('');
  };
  const handleClose = () => {
    setShowModal(false);
    setIsModalInfo(false);
    setCommune("");
    setProvince("");
    setDistrict("");
    setStatus("Tất cả");
    setNameCamera('');
  };
  const handleOK = (item) => {
    setListCamSelect([...listCamSelect, ...item]);
  };
  const onChangeNameGroup = (data) => {
    setGroup({ ...group, SUBJECT_NAME: data });
  };
  const showModalInfo = (id) => {
    setIsModalInfo(true);
    setCode(id);
  };
  // sua nhom
  const handleUpdateGroup = async () => {
    setLoading(!loading)
    try {
      if (listCamSelect.length > 0) {
        const listCam = listCamSelect.map((item) => {
          return { camera_code: item?.CODE, prioritized: "1" };
        });
        const data = JSON.stringify({
          subject_name: group?.SUBJECT_NAME && group?.SUBJECT_NAME?.trim().length > 0 ? group?.SUBJECT_NAME : 'Nhóm chưa đặt tên',
          list_group_cam: { data: listCam },
        });
        await groupCameraManagement.update(params.id, data);
        setLoading(false)
        setIsRefresh(!isRefresh);
        Toast.open("Chỉnh sửa nhóm thành công", "success");
        navigate(-1, { replace: true });
      }
    } catch (e) {
      setLoading(false)
      if (e.response.status === 403) {
        Toast.open("Bạn không có quyền chỉnh sửa nhóm camera", "danger");
      } else {
        Toast.open("Chỉnh sửa nhóm không thành công", "danger");
      }
    }
  };
  useEffect(() => {
    async function getData() {
      const param = {
        group_camera_code: params.id,
        camera_status: status === "Tất cả" ? null : status,
        commune_code: commune ? commune : null,
        district_code: district ? district : null,
        province_code: province ? province : null,
        camera_name: nameCamera ? nameCamera : null,
      }
      const res = await axiosClient.get(`/camerainfo/get-list-camera-not-in-group/`, {
        params: param
      }
      );
      setGroup(res.GROUP);
      setListCamera(res.LIST_CAMERA);
    }
    getData();
  }, [params.id, status, district, province, commune, nameCamera]);

  const { data } = useFetchData(
    `/cameraManagement/get-list-camera/?group_code=${params.id}`,
    {
      isRefresh: isRefresh,
      camera_name: textSearch,
    }
  );
  const cameraInfo = useFetchData(
    `cameraManagement/get-camera-info-by-code/?camera_code=${code}`
  );
  useEffect(() => {
    if (data.data) {
      const list = data?.data?.map((item) => item.CAMERA);
      setListCamSelect(list);
    }
  }, [data]);

  // xoa cam 
  const handleRemoveCamera = (code) => {
    const listCam = listCamSelect.filter(item => item.CODE !== code);
    setListCamSelect(listCam)
  };

  const handleCancel = () => {
    navigate(-1, { replace: false })
  }
  return (
    <>
      {showModal && (
        <ModalCamera
          onClose={handleClose}
          listCam={listCamera}
          onOK={handleOK}
          setProvince={setProvince}
          setCommune={setCommune}
          setDistrict={setDistrict}
          setNameCamera={setNameCamera}
          setStatus={setStatus}
        />
      )}
      <div className={cx("group")}>
        <div className={cx("header")}>
          <span className={cx("icon")}>
            <Link to="/admin/camera_group">
              <Previous />
            </Link>
          </span>
          <h1 className={cx("title")}>
            {group?.SUBJECT_NAME ? group?.SUBJECT_NAME : "Chỉnh sửa nhóm"}
          </h1>
        </div>
        <div className={cx("content")}>
          <div className={cx("form-add")}>
            <div className={cx("header", "sub")}>
              <h1 className={cx("title", "sub-title")}>Thông tin chung</h1>
            </div>
            <div className={cx("form")}>
              <InputTextBox
                style={{ marginBottom: 16 }}
                type="text"
                placeholder="Nhập"
                title="Tên nhóm camera"
                onChange={onChangeNameGroup}
                value={group?.SUBJECT_NAME ? group.SUBJECT_NAME : ""}
              />
              <InputTextBox
                style={{ marginBottom: 16 }}
                type="text"
                placeholder="Nhập"
                title="Người sửa cuối"
                onChange={onChangeNameGroup}
                value={group?.SUBJECT_NAME ? group.EDIT_USER : ""}
                disabled
              />
              <div className={cx('date-picker')}>
                <InfoUserItem label="Sửa lần cuối" type={'date'} value={group?.EDIT_TIME && formatDDMMYY(group?.EDIT_TIME)} disabled full />
              </div>
            </div>
          </div>
          <div className={cx("list-camera")}>
            <div className={cx("header", "sub")}>
              <h1 className={cx("title", "sub-title")}>Camera</h1>
            </div>
            <div className={cx("search")}>
              <div className={cx("title-list")}>
                <List />
                <button onClick={handleClick} className={cx('button-show-list-camera')}>Xem danh sách Camera</button>
              </div>
              <div className={cx("search-form")}>
                <InputTextBox
                  style={{ paddingTop: 2 }}
                  type="text"
                  placeholder="Tìm kiếm"
                  className={cx("pd")}
                  value={input}
                  onChange={onChangeTextSearch}
                />
                <span className={cx("icon-search")}>
                  <SearchBlack />
                </span>
              </div>
            </div>
            <TableCamera
              listCamSelect={listCamSelect}
              showModalInfo={showModalInfo}
              handleRemoveCamera={handleRemoveCamera}
              handleClick={handleClick}
            />
          </div>
        </div>
        <div className={cx("footer")}>
          <button onClick={handleUpdateGroup} className={cx("btn-add")}>
            Xác nhận
          </button>
          <button className={cx("btn-cancel")} onClick={handleCancel}>Hủy bỏ</button>
        </div>
      </div>
      <ModalInfo
        camera={cameraInfo.data}
        onClose={handleClose}
        show={isModalInfo}
        loading={cameraInfo.loading}
      />
      {
        loading && (
          <div className={cx('loading-modal')}>
            <Loading />
          </div>
        )
      }
    </>
  );
};
export default EditGroup;
